import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { PerformanceActionType, PerformanceStore } from './PerformanceReducer.types';

// @ts-ignore
const initialState: PerformanceStore = Immutable.fromJS({
  data: Immutable.List(),
  isFetching: false,
  failure: false,
});

const PerformanceReducer = handleActions(
  {
    DASHBOARD_PERFORMANCE_REQUEST: (state: PerformanceStore) => state.set('isFetching', true),

    DASHBOARD_PERFORMANCE_RESPONSE_FAILURE: (state: PerformanceStore) => state.set('isFetching', false).set('failure', true),

    AUTHENTICATION_LOGOUT: () => initialState,

    DASHBOARD_PERFORMANCE_RESPONSE: (state: PerformanceStore, action: PerformanceActionType) =>
      state.set('isFetching', false).set('data', Immutable.fromJS(action.payload.data)).set('failure', false),
  },
  initialState
);

export default PerformanceReducer;
